/**
 * Validation for the automation-rule admin endpoints.
 *
 * Rules are seeded by migration; the admin UI exposes only edit
 * (toggle is_enabled, edit config_json). Create/delete is a v2
 * concern — the rule set is stable for v1.
 */

import { z } from 'zod';

export const automationUpdateInputSchema = z.object({
  isEnabled: z.boolean().optional(),
  /** Free-form JSON config — schema-checked per-rule downstream. */
  configJson: z.record(z.unknown()).optional(),
});
export type AutomationUpdateInput = z.infer<
  typeof automationUpdateInputSchema
>;
